import { emitter, EventEnum } from '@star/utils';
import { onUnmounted } from 'vue';
import { useAppStore } from '@star/stores';
import { useRoute } from 'vue-router';
import { promiseTimeout } from '@vueuse/core';

type Options = {
  refresh?: boolean;
};

export default function usePageLoad(fn: () => Promise<any>, options?: Options) {
  const appStore = useAppStore();
  const route = useRoute();

  const refreshCallback = async () => {
    try {
      await fn?.();
    } finally {
      appStore.setPullRefresh(!!options?.refresh);
    }
  };

  const init = async () => {
    try {
      appStore.setPageLoading(!!route.meta?.loading);
      await fn?.();
    } finally {
      await promiseTimeout(300);
      appStore.setPageLoading(false);
    }
  };

  emitter.on(EventEnum.REFRESH_PAGE, refreshCallback);

  onUnmounted(() => {
    emitter.off(EventEnum.REFRESH_PAGE, refreshCallback);
  });

  return {
    init,
  };
}
